import { render, staticRenderFns } from "./QuestionBreakdown.vue?vue&type=template&id=360c9a39&scoped=true&"
import script from "./QuestionBreakdown.vue?vue&type=script&lang=js&"
export * from "./QuestionBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./QuestionBreakdown.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./QuestionBreakdown.vue?vue&type=style&index=1&id=360c9a39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360c9a39",
  null
  
)

export default component.exports